'use client'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Separator,
} from '@repo/ui'
import { Button } from '@repo/ui/components'
import { Minus, Plus } from 'lucide-react'
import { Control, useWatch } from 'react-hook-form'
import { z } from 'zod'

interface Props {
  control: Control<{ temperature: number }>
}

export const TemperatureInput = ({ control }: Props) => {
  'use memo'

  const temperatureWatch = useWatch({ control, name: 'temperature' })
  const showTemperatureControl = temperatureWatch !== undefined && temperatureWatch !== null

  return (
    showTemperatureControl && (
      <FormField
        control={control}
        name={'temperature'}
        render={({ field }) => {
          const handlePlus = () => {
            field.onChange(field.value + 1)
          }

          const handleMinus = () => {
            field.onChange(field.value - 1)
          }

          return (
            <FormItem className={'grow'}>
              <FormLabel className={'text-card-foreground'}>Temperature</FormLabel>
              <FormControl>
                <div className={'flex w-full items-center rounded border'}>
                  <div className={'flex w-40 shrink-0 items-center gap-1'}>
                    <Button
                      className={'shrink-0'}
                      onClick={handleMinus}
                      size={'icon'}
                      type={'button'}
                      variant={'ghost'}
                    >
                      <Minus />
                    </Button>
                    <Input
                      {...field}
                      className={'border-none text-center'}
                      onChange={event => {
                        field.onChange(z.coerce.number().optional().parse(event.target.value))
                      }}
                      placeholder={'0'}
                      type="number"
                      value={field.value.toString()}
                    />
                    <Button
                      className={'shrink-0'}
                      onClick={handlePlus}
                      size={'icon'}
                      type={'button'}
                      variant={'ghost'}
                    >
                      <Plus />
                    </Button>
                  </div>
                  <Separator className={'h-6'} orientation={'vertical'} />
                  <p className={'w-10 shrink-0 text-center'}>℃</p>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )
        }}
      />
    )
  )
}
